
import JobTitleInput from "../form-fields/JobTitleInput";
import CompanyInput from "../form-fields/CompanyInput";
import JobDescriptionInput from "../form-fields/JobDescriptionInput";

interface JobDetailsFormRefactoredProps {
  jobTitle: string;
  company: string;
  jobDescription: string;
  onJobTitleChange: (value: string) => void;
  onCompanyChange: (value: string) => void;
  onJobDescriptionChange: (value: string) => void;
}

const JobDetailsFormRefactored = ({
  jobTitle,
  company,
  jobDescription,
  onJobTitleChange,
  onCompanyChange,
  onJobDescriptionChange,
}: JobDetailsFormRefactoredProps) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <JobTitleInput value={jobTitle} onChange={onJobTitleChange} />
        <CompanyInput value={company} onChange={onCompanyChange} />
      </div>
      <JobDescriptionInput value={jobDescription} onChange={onJobDescriptionChange} />
    </div>
  );
};

export default JobDetailsFormRefactored;
